import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { MachineCheckSheet } from '@/pages/machine-checks/check/check-sheet';
import { MACHINE_CHECKS_ROUTE } from '@/pages/machine-checks/lib/routes';

export const Route = createFileRoute(
  '/protected/_layout/machine-checks/_layout/checks/$id'
)({
  ...createSheetRouteOptions(MACHINE_CHECKS_ROUTE, { size: 'wide' }),
  component: MachineCheckSheetRoute,
});

function MachineCheckSheetRoute() {
  const { id } = Route.useParams();
  return <MachineCheckSheet id={id} returnUrl={MACHINE_CHECKS_ROUTE} />;
}
